import React, { useEffect, useState } from 'react';
import { LuDownload } from 'react-icons/lu';
import moment from 'moment';
import axios from 'axios';
import { MdOutlineFindInPage ,MdOutlineAddCircleOutline } from "react-icons/md";
import dayjs from 'dayjs';
import ToastNotification from '../../../components/ToastNotification';

const GenPayroll = () => {
  const [payrollData, setPayrollData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format('YYYY-MM'));
  const [searchFilter, setSearchFilter] = useState('');
  const [payheadColumns, setPayheadColumns] = useState([]);
  const [showPayrollModal, setShowPayrollModal] = useState(false);
const [selectedEmployee, setSelectedEmployee] = useState(null);
const [additionalEarnings, setAdditionalEarnings] = useState([]);
const [deductions, setDeductions] = useState([]);
const [isPayrollViewOnly, setIsPayrollViewOnly] = useState(false);
const [showGenerateModal, setShowGenerateModal] = useState(false);
const [showViewModal, setShowViewModal] = useState(false);
const [existingPayroll, setExistingPayroll] = useState(null);
const [isCheckingPayroll, setIsCheckingPayroll] = useState(false);
const [payrollStatus, setPayrollStatus] = useState({}); 
const [monthlyAttendance, setMonthlyAttendance] = useState([]);




 const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

      const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };

  

  const fetchEmployeeData = async () => {
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-payroll', {
      params: { month: selectedMonth }
    });
    const data = res.data.result;

    // const parsedData = data.map(emp => ({
    //   ...emp,
    //   payhead_data: emp.payhead_data ? JSON.parse(emp.payhead_data) : []
    // }));


    const parsedData = data
  .filter(emp => emp.emp_table_emp_id) // 👈 REMOVE null/undefined emp_id
  .map(emp => ({
    ...emp,
    payhead_data: emp.payhead_data ? JSON.parse(emp.payhead_data) : []
  }));

    setPayrollData(parsedData);



    const payheadsSet = new Set();
    parsedData.forEach(emp => {
      emp.payhead_data.forEach(ph => payheadsSet.add(ph.name));
    });
    setPayheadColumns(Array.from(payheadsSet));

  } catch (e) {
    console.error('Error fetching employee data:', e);
  }
};


  useEffect(() => {
    fetchEmployeeData();
  }, [selectedMonth]);

  const monthName = moment(selectedMonth, 'YYYY-MM').format('MMMM');
  const year = moment(selectedMonth, 'YYYY-MM').format('YYYY');

  const filteredByMonth = payrollData; 

  const searchedData = filteredByMonth.filter((itm) =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchFilter.toLowerCase())
    )
  );



const monthToCheck = selectedMonth;
const generatePayroll = async () => {
  try {
  
    const empId = selectedEmployee.emp_table_emp_id;
    const empName = `${selectedEmployee.first} ${selectedEmployee.middle} ${selectedEmployee.last}`;
    const month = selectedMonth;


    const adjustedBasic = Number(selectedEmployee.attendanceSummary?.adjustedBasic || selectedEmployee.basic || 0);
    const payheads = selectedEmployee.payhead_data || [];


    const additionalEarningsData = additionalEarnings || [];
    const deductionsData = deductions || [];

    const paidDays = Number(selectedEmployee.attendanceSummary?.paidDays || 0);
    const absent = Number(selectedEmployee.attendanceSummary?.absent || 0);


    const totalPayheads = payheads.reduce((sum, ph) => sum + Number(ph.amount), 0);
    const totalAdditional = additionalEarningsData.reduce((sum, ae) => sum + Number(ae.amount), 0);
    const totalDeductions = deductionsData.reduce((sum, d) => sum + Number(d.amount), 0);

    const netSalary = adjustedBasic + totalPayheads + totalAdditional - totalDeductions;
    console.log("Calculated Net Salary:", netSalary);

    // Prepare FormData
    const formData = new FormData();
    formData.append('empId', empId);
    formData.append('empName', empName);
    formData.append('month', month);
    formData.append('basicSalary', selectedEmployee.basic);
    formData.append('payheads', JSON.stringify(payheads));
    formData.append('additionalEarnings', JSON.stringify(additionalEarningsData));
    formData.append('deductions', JSON.stringify(deductionsData));
    formData.append('paid_days', paidDays);
    formData.append('absent_days', absent);
    formData.append('net_salary',netSalary)

    // Send request
    const response = await axios.post(
      "https://api.skyguard.group/api/generate-payroll",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    console.log('Payroll saved:', response.data);
    showToast('Payroll generated successfully!', 'success');
      setShowViewModal(false);

  } catch (err) {
    console.error("Payroll Generation Error:", err);
    showToast('Error generating payroll', 'danger');
  }
};


const handlePayrollClick = async (emp) => {
  try {

 
    const attendance = await fetchEmployeeMonthlyAttendance(emp.emp_table_emp_id);

    const summary = calculateAttendanceSummary(
      attendance,
      Number(emp.basic || 0)
    );


    const res = await fetch(
      `https://api.skyguard.group/api/get-payroll?empId=${emp.emp_table_emp_id}&month=${selectedMonth}`
    );

    const data = await res.json();

    if (data.exists) {

      setPayrollStatus(prev => ({ ...prev, [emp.emp_table_emp_id]: true }));

      const payroll = data.payroll;
      payroll.payheads = JSON.parse(payroll.payheads || "[]");
      payroll.additional_earnings = JSON.parse(payroll.additional_earnings || "[]");
      payroll.deductions = JSON.parse(payroll.deductions || "[]");

      setSelectedEmployee({
        ...emp,
        attendanceSummary: summary
      });

      setExistingPayroll(payroll);
      setShowPayrollModal(false);
      setShowViewModal(true);

    } else {

      setPayrollStatus(prev => ({ ...prev, [emp.emp_table_emp_id]: false }));

      setSelectedEmployee({
        ...emp,
        attendanceSummary: summary
      });

      setAdditionalEarnings([]);
      setDeductions([]);

      setShowViewModal(false);
      setShowPayrollModal(true);
    }

  } catch (err) {
    console.error(err);
  }
};



const fetchMonthlyAttendance = async (empId) => {
  try {
    const res = await axios.get("https://api.skyguard.group/api/get-attendance", {
      params: {
        emp_id: empId,
        month: selectedMonth
      }
    });


    console.log(res.data,'daata from attendancce ')

    return res.data.data || [];
  } catch (err) {
    console.error("Error fetching attendance:", err);
    return [];
  }
};

const calculateAttendanceSummary = (attendance, basicSalary) => {

  let totalHours = 0;
  let present = 0;
  let absent = 0;
  let leave = 0;

  attendance.forEach(record => {

    if (record.check_in && record.check_out) {
      const start = new Date(`1970-01-01T${record.check_in}`);
      const end = new Date(`1970-01-01T${record.check_out}`);
      totalHours += (end - start) / (1000 * 60 * 60);
    }

    if (record.type === "Present") present++;
    if (record.type === "Absent") absent++;
    if (record.type === "Leave") leave++;

  });

  const daysInMonth = dayjs(selectedMonth).daysInMonth();
  const perDaySalary = basicSalary / daysInMonth;

  const absentDeduction = absent * perDaySalary;

  const paidDays = present + leave; 

  const adjustedBasic = basicSalary - absentDeduction;

  console.log("Attendance Records:", attendance);
console.log("Calculated Summary:", {
  totalHours,
  present,
  absent,
  leave
});

attendance.forEach(r => {
  console.log("CheckIn:", r.check_in);
  console.log("CheckOut:", r.check_out);
});

  return {
    totalHours,
    present,
    absent,
    leave,
    paidDays,
    absentDeduction,
    adjustedBasic
  };
};


const fetchEmployeeMonthlyAttendance = async (empId) => {
  try {
    const res = await axios.get(
      "https://api.skyguard.group/api/monthly-attendance",
      {
        params: {
          month: selectedMonth,
          emp_id: empId
        }
      }
    );

    return res.data.data || [];

  } catch (error) {
    console.error("Error fetching attendance:", error);
    return [];
  }
};

  return (
    <div className='main-section'>
       <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast(prev => ({ ...prev, show: false }))}
                  style={{
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 20000,   
  }}
            />
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        
        <h3 className='my-3 fw-bold fs-5 golos'>Generate Payroll</h3>
        <div className="mb-3 row gx-3 gy-2 align-items-center">
          <div className="col-12 col-md-5">
            <label htmlFor="searchInput" className="form-label fw-medium">Search Employee:</label>
            <input
              type="text"
              className="form-control"
              id="searchInput"
              placeholder="Search..."
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
            />  
          </div>
          <div className="col-12 col-md-4">
            <label htmlFor="attendanceDate" className="form-label fw-medium">Select Month:</label>
            <input
              type="month"
              className="form-control"
              id="attendanceDate"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            />
          </div>
      
        </div>

        <h5 className="text-primary fw-bold bg-white p-3 rounded border shadow-sm mb-4 text-center">
          Payroll for: <span className="text-dark">{monthName} - {year}</span>
        </h5>

        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover table-sm text-center align-middle'>
            <thead className='table-info'>
              <tr>
                      <th>Action </th>
                <th>Emp ID</th>
                <th>Employee Name</th>
            
                <th>Email</th>
                <th>Department</th>
                <th>Designation</th>
                {/* <th>DOJ</th> */}
          
        
              </tr>
            </thead>
            <tbody>
              {searchedData.length > 0 ? (
                searchedData.map((emp, index) => (
                  <tr key={index}>
                    <td>
  {payrollStatus[emp.emp_table_emp_id] ? (
    <MdOutlineFindInPage
      title="View Payroll"
      size={20}
      style={{ cursor: 'pointer', color: 'green' }}
      onClick={() => handlePayrollClick(emp)}
    />
  ) : (
    <MdOutlineAddCircleOutline
      title="Generate Payroll"
      size={20}
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handlePayrollClick(emp)}
    />
  )}
</td>
                    <td>{emp.emp_table_emp_id}</td>
                    <td>{emp.first} {emp.middle} {emp.last}  </td>
                   
                    <td>{emp.email}</td>
                    <td>{emp.department || '-'}</td>
                    <td>{emp.designation || '-'}</td>
            


                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9 + payheadColumns.length} className='text-start text-muted'>No data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

{showPayrollModal && selectedEmployee && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, padding: '20px' }}
  >
    <div
      className="bg-white rounded shadow overflow-auto"
      style={{ width: '800px', maxHeight: '95vh' }}
    >
      {/* Header */}
      <div
        className="bg-primary text-white py-3 text-center position-relative rounded-top"
        style={{ fontSize: '1.8rem', fontWeight: 'bold' }}
      >
        Payroll
        <button
          className="btn-close position-absolute top-50 end-0 translate-middle-y me-3"
          onClick={() => setShowPayrollModal(false)}
        />
      </div>

      {/* Modal Body */}
      <div className="p-4" style={{ backgroundColor: '#f8f9fa' }}>
        {/* Employee Info Box */}
        <div className="bg-white p-3 rounded shadow mb-4">
          <div className="d-flex justify-content-between flex-wrap">
            <div style={{ minWidth: '200px' }}>
              <p className='mb-0' ><strong>EMP ID:</strong> {selectedEmployee.emp_table_emp_id}</p>
              <p className='mb-0'><strong>Name:</strong> {selectedEmployee.first} {selectedEmployee.middle} {selectedEmployee.last}</p>
              <p className='mb-0'><strong>Email:</strong> {selectedEmployee.email}</p>
                <p className='mb-0'><strong>Department:</strong> {selectedEmployee.department || '-'}</p>
              <p className='mb-0'><strong>Designation:</strong> {selectedEmployee.designation || '-'}</p>
            </div>
            <div style={{ minWidth: '200px', textAlign: 'left' }}>
            
              <p className='mb-0'><strong>Basic Salary:</strong> {selectedEmployee.basic || 0}</p>
              <p className='mb-0'>
  <strong>Paid Days:</strong>{" "}
  {selectedEmployee.attendanceSummary?.paidDays || 0}
</p>

<p className='mb-0'>
  <strong>Absent Days:</strong>{" "}
  {selectedEmployee.attendanceSummary?.absent || 0}
</p>

<p className='mb-0'>
  <strong>Total Work Hours:</strong>{" "}
  {selectedEmployee.attendanceSummary?.totalHours?.toFixed(2) || 0}
</p>


            </div>
          </div>
        </div>

        {/* Main Payhead Table */}
        <div className="bg-white p-3 rounded shadow mb-4 mx-auto" style={{ maxWidth: '800px' }}>
          <h5 className="text-center mb-3">Payheads</h5>
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>Description</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {selectedEmployee.payhead_data &&
                selectedEmployee.payhead_data.map((ph, idx) => (
                  <tr key={idx}>
                    <td>{ph.name}</td>
                    <td className="text-end">{ph.amount}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

 
<div className="d-flex gap-4 mb-4">
  {/* Left Column: Additional Earnings */}
  <div className="bg-white p-3 rounded shadow flex-fill">
    <h6 className="text-center">Additional Earnings</h6>
    {/* Add Row */}
    <div className="d-flex gap-2 mb-2">
      <input type="text" placeholder="Earning Name" className="form-control form-control-sm" id="newEarningName" />
      <input type="number" placeholder="Amount" className="form-control form-control-sm" id="newEarningAmount" />
          <button
        className="btn btn-sm btn-success"
        onClick={() => {
          const name = document.getElementById('newEarningName').value;
          const amount = Number(document.getElementById('newEarningAmount').value);
          if (name && amount) {
            setAdditionalEarnings([...additionalEarnings, { name, amount }]);
            document.getElementById('newEarningName').value = '';
            document.getElementById('newEarningAmount').value = '';
          }
        }}
      >
        Add
      </button>
   
    </div>
    <table className="table table-bordered mb-0">
      <thead className="table-light">
        <tr>
          <th>Description</th>
          <th className="text-end">Amount</th>
          <th className="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        {additionalEarnings.map((ae, idx) => (
          <tr key={idx} style={{ backgroundColor: '#d4edda' }}>
            <td>{ae.name}</td>
            <td className="text-end">{ae.amount}</td>
            <td className="text-center">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => setAdditionalEarnings(additionalEarnings.filter((_, i) => i !== idx))}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Right Column: Deductions */}
  <div className="bg-white p-3 rounded shadow flex-fill">
    <h6 className="text-center">Deductions</h6>
    {/* Add Row */}
    <div className="d-flex gap-2 mb-2">
      <input type="text" placeholder="Deduction Name" className="form-control form-control-sm" id="newDeductionName" />
      <input type="number" placeholder="Amount" className="form-control form-control-sm" id="newDeductionAmount" />
      <button
        className="btn btn-sm btn-success"
        onClick={() => {
          const name = document.getElementById('newDeductionName').value;
          const amount = Number(document.getElementById('newDeductionAmount').value);
          if (name && amount) {
            setDeductions([...deductions, { name, amount }]);
            document.getElementById('newDeductionName').value = '';
            document.getElementById('newDeductionAmount').value = '';
          }
        }}
      >
        Add
      </button>
    </div>
    <table className="table table-bordered mb-0">
      <thead className="table-light">
        <tr>
          <th>Description</th>
          <th className="text-end">Amount</th>
          <th className="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        {deductions.map((ded, idx) => (
          <tr key={idx} style={{ backgroundColor: '#f8d7da' }}>
            <td>{ded.name}</td>
            <td className="text-end">{ded.amount}</td>
            <td className="text-center">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => setDeductions(deductions.filter((_, i) => i !== idx))}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

        {/* Net Salary Box */}
        <div className="bg-white p-3 rounded shadow mb-3" style={{ width: '250px' }}>
          <h6>Net Salary</h6>
          <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
         
            {/* {(
  Number(selectedEmployee.basic || 0) +
  selectedEmployee.payhead_data.reduce((sum, ph) => sum + Number(ph.amount), 0) +
  additionalEarnings.reduce((sum, ae) => sum + Number(ae.amount), 0) -
  deductions.reduce((sum, d) => sum + Number(d.amount), 0)
).toFixed(2)} */}

{(
  Number(selectedEmployee.attendanceSummary?.adjustedBasic || selectedEmployee.basic || 0) +
  selectedEmployee.payhead_data.reduce((sum, ph) => sum + Number(ph.amount), 0) +
  additionalEarnings.reduce((sum, ae) => sum + Number(ae.amount), 0) -
  deductions.reduce((sum, d) => sum + Number(d.amount), 0)
).toFixed(2)}
          </p>
        </div>

        {/* Generate Payroll Button */}
        <div className="text-end mt-3">
  <button className="btn btn-primary" onClick={generatePayroll}>
    Generate Payroll
  </button>
</div>
      </div>
    </div>
  </div>
)}


{showViewModal && existingPayroll && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, padding: '20px' }}
  >
    <div
      className="bg-white rounded shadow overflow-auto"
      style={{ width: '800px', maxHeight: '95vh' }}
    >
      {/* Header */}
      <div
        className="bg-success text-white py-3 text-center position-relative rounded-top"
        style={{ fontSize: '1.8rem', fontWeight: 'bold' }}
      >
      View  Payroll
        <button
          className="btn-close position-absolute top-50 end-0 translate-middle-y me-3"
          onClick={() => setShowViewModal(false)}
        />
      </div>

      <div className="p-4" style={{ backgroundColor: '#f8f9fa' }}>

        {/* Employee Info */}
        <div className="bg-white p-3 rounded shadow mb-4">
          <div className="d-flex justify-content-between flex-wrap">
            <div style={{ minWidth: '200px' }}>
              <p className='mb-0'><strong >EMP ID:</strong> {existingPayroll.emp_id}</p>
              <p className='mb-0'><strong >Name:</strong> {existingPayroll.emp_name}</p>
              <p className='mb-0'><strong>Month:</strong> {existingPayroll.month}</p>
               {/* <p className='mb-0'><strong>Department:</strong> {existingPayroll.department || '-'}</p>
              <p className='mb-0'><strong>Designation:</strong> {existingPayroll.designation || '-'}</p> */}
            </div>
            <div style={{ minWidth: '200px' }}>
              <p className='mb-0'><strong>Basic Salary:</strong> {existingPayroll.basic_salary}</p>
                           <p className='mb-0'>
  <strong>Paid Days:</strong>{" "}
  {existingPayroll.paid_days || 0}
</p>

<p className='mb-0'>
  <strong>Absent Days:</strong>{" "}
  {existingPayroll.absent_days || 0}
</p>
              <p className='mb-0'><strong>Net Salary:</strong> {existingPayroll.net_salary}</p>
            </div>
          </div>
        </div>

        {/* Payheads */}
        <div className="bg-white p-3 rounded shadow mb-4">
          <h5 className="text-center mb-3">Payheads</h5>
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>Description</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {(existingPayroll.payheads || []).map((ph, idx) => (
                <tr key={idx}>
                  <td>{ph.name}</td>
                  <td className="text-end">{ph.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Earnings & Deductions Side by Side */}
        <div className="d-flex gap-4 mb-4">

          {/* Additional Earnings */}
          <div className="bg-white p-3 rounded shadow flex-fill">
            <h6 className="text-center">Additional Earnings</h6>
            <table className="table table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>Description</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(existingPayroll.additional_earnings || []).map((ae, idx) => (
                  <tr key={idx} style={{ backgroundColor: '#d4edda' }}>
                    <td>{ae.name}</td>
                    <td className="text-end">{ae.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Deductions */}
          <div className="bg-white p-3 rounded shadow flex-fill">
            <h6 className="text-center">Deductions</h6>
            <table className="table table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>Description</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(existingPayroll.deductions || []).map((ded, idx) => (
                  <tr key={idx} style={{ backgroundColor: '#f8d7da' }}>
                    <td>{ded.name}</td>
                    <td className="text-end">{ded.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

        {/* Net Salary Box */}
        <div className="bg-white p-3 rounded shadow" style={{ width: '250px' }}>
          <h6>Net Salary</h6>
          <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            {existingPayroll.net_salary}
          </p>
        </div>

      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default GenPayroll;









